import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "content-block chat-messages" }
const _hoisted_2 = {
  key: 0,
  class: "chat-messages__container-divider"
}

import { computed } from "vue";
import {
	useRoute,
	useRouter
} from "vue-router";
import {
	ChatModes,
	chatsStore,
	Dialog
} from "@/store/chats";
import ChatDialog from "@/components/main/chat-panel/ChatDialog.vue";
import ChatDialogsEmpty from "@/components/main/chat-panel/ChatDialogsEmpty.vue";
import AppLoader from "@/components/common/AppLoader.vue";


type ChatMessagesPanelProps = {
	loading: boolean;
	dialogs: Dialog[],
	mode: ChatModes
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatDialogsPanel',
  props: {
    loading: { type: Boolean },
    dialogs: {},
    mode: {}
  },
  emits: ["on-open", "on-delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const route = useRoute()
const router = useRouter()
const store = chatsStore()
const emit = __emit

const isLoading = computed(() => store.loadingDialogs)
const isEmpty = computed(() => store.dialogsLoaded && !isLoading.value && !props.dialogs.length)

const onOpenDialog = (dialog: Dialog) => emit("on-open", dialog)
const onDeleteDialog = (dialogId: number) => emit("on-delete", dialogId)

const onCreateChat = async () => {
	await router.push({
		path: '/',
		query: {
			...route.query,
			mode: 'create-chat'
		}
	});
	store.setMode('create-chat')
	store.setOpenedChat(null)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({
				'chat-messages__container': true,
				'chat-messages__container--empty': isEmpty.value
			})
    }, [
      (isLoading.value && !props.dialogs.length)
        ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
        : (isEmpty.value)
          ? (_openBlock(), _createBlock(ChatDialogsEmpty, {
              key: 1,
              onOnCreate: onCreateChat
            }))
          : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dialogs, (dialog, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: dialog.Id
        }, [
          _createVNode(ChatDialog, {
            dialog: dialog,
            onOnOpen: onOpenDialog,
            onOnDelete: onDeleteDialog
          }, null, 8, ["dialog"]),
          (index < _ctx.dialogs.length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ], 2)
  ]))
}
}

})